<div class="grid grid-cols-12 gap-4 px-4 pb-4 h-full">
  <div class="col-span-12 min-[1400px]:col-span-8 rounded-lg challenges h-full overflow-hidden">
    <app-challenges-sub-challenges />
  </div>
  <div class="col-span-12 min-[1400px]:col-span-4 bg-white rounded-lg h-full overflow-hidden">
    <app-selected-pair-challenges />
  </div>
</div>
